import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dimmer, Loader} from 'semantic-ui-react';
import ThreeComponent from './ThreeComponent';
import Model from './Model';

const RACE_KEY = 'model-viewer-race';
const SEX_KEY = 'model-viewer-sex';

export default class SimpleModelViewer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sex: localStorage.getItem(SEX_KEY) || 'female',
            race: localStorage.getItem(RACE_KEY) || 'human',
            isLoading: false,
        };
    }

    componentWillUnmount() {
        localStorage.setItem(RACE_KEY, this.state.race);
        localStorage.setItem(SEX_KEY, this.state.sex)
    }

    render() {
        const {isLoading, race, sex} = this.state;
        const {appearanceId, model, width} = this.props;

        const sizeStyle= (width) ?
                         {minWidth: width, minHeight: width} :
                         {};

        const rotationInfo = model.getRotationalInformation();
        const modelString = `${appearanceId}_${race}_${sex}`;

        return (
            <div style={sizeStyle}>
                <Dimmer active={isLoading}>
                    <Loader>Loading model</Loader>
                </Dimmer>
                <ThreeComponent model={modelString} rotation={rotationInfo} onLoading={(isLoading) => {this.setState({isLoading: isLoading})}} />
            </div>
        )
    }
}

SimpleModelViewer.propTypes = {
    appearanceId: PropTypes.string.isRequired,
    model: PropTypes.instanceOf(Model).isRequired,
    width: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/common/model-viewer/SimpleModelViewer.jsx